import React, { FC } from 'react';
import styled from 'styled-components';

interface NavigationProps {
  theme?: string;
  position: string;
  sysId: string;
  navigationArrows: boolean;
  direction?: 'prev' | 'next';
  onPrevClick?: () => void;
  onNextClick?: () => void;
}

const Wrapper = styled.div<{ $position: string }>`
  .controls-navigation {
    display: flex;
    flex-direction: ${({ $position }) =>
      $position == 'left' || $position == 'right' ? 'column' : 'row'};
    align-items: center;
    gap: 30px;
  }

  ${({ $position }) =>
    ($position == 'top' || $position == 'bottom') &&
    `
      .controls-button-prev svg { transform: rotate(-90deg); }
      .controls-button-next svg { transform: rotate(-90deg); }
    `}
`;

const ArrowBtn = styled.button<{ themeName?: string }>`
  all: unset;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  svg path {
    fill: ${({ themeName }) => (themeName == 'dark' ? '#fff' : '#191A1F')};
  }
`;

const PrevIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
    <path d="M5.25 11C5.25 11.4142 5.58579 11.75 6 11.75C6.41421 11.75 6.75 11.4142 6.75 11H5.25ZM6.53033 0.46967C6.23744 0.176777 5.76256 0.176777 5.46967 0.46967L0.696699 5.24264C0.403806 5.53553 0.403806 6.01041 0.696699 6.3033C0.989593 6.59619 1.46447 6.59619 1.75736 6.3033L6 2.06066L10.2426 6.3033C10.5355 6.59619 11.0104 6.59619 11.3033 6.3033C11.5962 6.01041 11.5962 5.53553 11.3033 5.24264L6.53033 0.46967ZM6.75 11L6.75 1H5.25L5.25 11H6.75Z" />
  </svg>
);

const NextIcon = () => (
  <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
    <path d="M6.75 1C6.75 0.585786 6.41421 0.25 6 0.25C5.58579 0.25 5.25 0.585786 5.25 1H6.75ZM5.46967 11.5303C5.76256 11.8232 6.23744 11.8232 6.53033 11.5303L11.3033 6.75736C11.5962 6.46447 11.5962 5.98959 11.3033 5.6967C11.0104 5.40381 10.5355 5.40381 10.2426 5.6967L6 9.93934L1.75736 5.6967C1.46447 5.40381 0.989593 5.40381 0.696699 5.6967C0.403806 5.98959 0.403806 6.46447 0.696699 6.75736L5.46967 11.5303ZM5.25 1L5.25 11H6.75L6.75 1H5.25Z" />
  </svg>
);

const Navigation: FC<NavigationProps> = ({
  theme,
  position,
  sysId,
  navigationArrows,
  direction,
  onPrevClick,
  onNextClick,
}) => {
  if (!navigationArrows) return null;

  return (
    <Wrapper $position={position}>
      <div className="controls-navigation">
        {(direction == 'prev' || !direction) && (
          <ArrowBtn
            themeName={theme}
            type="button"
            aria-label="Previous slide"
            className={`controls-button-prev controls-button-prev-${sysId}`}
            onClick={onPrevClick}
          >
            <PrevIcon />
          </ArrowBtn>
        )}
        {(direction == 'next' || !direction) && (
          <ArrowBtn
            themeName={theme}
            type="button"
            aria-label="Next slide"
            className={`controls-button-next controls-button-next-${sysId}`}
            onClick={onNextClick}
          >
            <NextIcon />
          </ArrowBtn>
        )}
      </div>
    </Wrapper>
  );
};

export default Navigation;